<template>
  <v-container
    id="master-sub-category"
    fluid
    tag="section"
    class="cyber-mapping-container"
  >
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="#018C74"
          icon="mdi-sitemap-outline"
          class="glass-card mb-0"
        >
          <template v-slot:heading>
            <div class="display-2 font-weight-black cyber-text">SUB-KATEGORI</div>
            <div class="subtitle-1 secondary-text">
              <v-icon x-small color="#CFA22D">mdi-link-variant</v-icon>
              Relasi Sub-Kategori & Status Operasional
            </div>
          </template>

          <v-card-text class="mt-6">
            <v-row class="mb-6 align-center">
              <v-col cols="12" md="6">
                <v-btn class="cyber-btn-add" @click="openDialog()">
                  <v-icon left>mdi-plus-network</v-icon>
                  INPUT SUB-KATEGORI
                </v-btn>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-database-search-outline"
                  label="Cari Sub-Kategori..."
                  single-line
                  hide-details
                  rounded
                  color="#CFA22D"
                  class="cyber-search"
                />
              </v-col>
            </v-row>

            <v-data-table
              :headers="headers"
              :items="subList"
              :search="search"
              :loading="loading"
              class="cyber-table"
            >
              <template v-slot:item.category_name="{ item }">
                <v-chip
                  small
                  outlined
                  color="#CFA22D"
                  class="font-weight-bold cyber-chip"
                >
                  <v-icon x-small left>mdi-folder-zip-outline</v-icon>
                  {{ item.category_name }}
                </v-chip>
              </template>

              <template v-slot:item.nama_sub="{ item }">
                <span class="white--text font-weight-medium text-uppercase">{{
                  item.nama_sub
                }}</span>
              </template>

              <template v-slot:item.is_active="{ item }">
                <v-chip
                  small
                  :color="item.is_active == 1 ? '#018C74' : '#CFA22D'"
                  class="font-weight-black"
                  label
                  outlined
                >
                  <v-icon x-small left>{{
                    item.is_active == 1 ? "mdi-check-decagram" : "mdi-alert-octagon"
                  }}</v-icon>
                  {{ item.is_active == 1 ? "AKTIF" : "NON-AKTIF" }}
                </v-chip>
              </template>

              <template v-slot:item.icon_subcategories="{ item }">
                <div class="icon-scan-frame">
                  <v-img
                    v-if="item.icon_subcategories"
                    :src="item.icon_url"
                    max-width="45"
                    max-height="45"
                    class="rounded-lg shadow-glow-teal"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="#018C74" size="20" />
                      </v-row>
                    </template>
                  </v-img>
                  <v-icon v-else color="rgba(255,255,255,0.1)" large
                    >mdi-integrated-circuit-chip</v-icon
                  >
                </div>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn
                  icon
                  color="#018C74"
                  class="glow-hover mr-2"
                  @click="openDialog(item)"
                >
                  <v-icon small>mdi-pencil-box-outline</v-icon>
                </v-btn>
                <v-btn
                  icon
                  color="#ff5252"
                  class="glow-hover-red"
                  @click="deleteItem(item)"
                >
                  <v-icon small>mdi-delete-variant</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="dialog"
      max-width="500px"
      persistent
      overlay-color="#001a16"
      overlay-opacity="0.9"
    >
      <v-card class="cyber-modal">
        <div class="modal-header-line" />
        <v-card-title class="pa-5 d-flex align-center">
          <v-icon left color="#CFA22D">mdi-database-edit-outline</v-icon>
          <span class="text-h5 font-weight-black white--text">{{ formTitle }}</span>
          <v-spacer />
          <v-btn icon @click="close" x-small><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="pt-6">
          <v-autocomplete
            v-model="editedItem.category_id"
            :items="categoryOptions"
            item-text="nama_kategori"
            item-value="id"
            label="INDUK KATEGORI"
            outlined
            color="#018C74"
            class="cyber-input"
            prepend-inner-icon="mdi-folder-network-outline"
            clearable
          />

          <v-text-field
            v-model="editedItem.nama_sub"
            label="JENIS SUB KATEGORI"
            outlined
            color="#018C74"
            class="cyber-input"
            prepend-inner-icon="mdi-rename-box"
          />

          <v-switch
            v-model="editedItem.is_active"
            :label="`STATUS AKTIVASI: ${
              editedItem.is_active == 1 ? 'AKTIF' : 'NON-AKTIF'
            }`"
            :true-value="1"
            :false-value="0"
            color="#018C74"
            inset
            class="cyber-input mb-4"
          ></v-switch>

          <v-file-input
            v-model="imageFile"
            label="UNGGAH VISUAL ICON"
            outlined
            color="#018C74"
            prepend-icon=""
            prepend-inner-icon="mdi-image-filter-center-focus-weak"
            accept="image/*"
            @change="createPreview"
            class="cyber-input"
          />

          <v-expand-transition>
            <div v-if="previewUrl" class="preview-container">
              <div class="scanning-line" />
              <v-img
                :src="previewUrl"
                max-height="120"
                contain
                class="rounded-lg shadow-glow-gold"
              />
              <div class="preview-tag">VISUAL PREVIEW</div>
            </div>
          </v-expand-transition>
        </v-card-text>

        <v-card-actions class="pa-6 pt-0">
          <v-btn
            text
            color="rgba(255,255,255,0.5)"
            @click="close"
            class="font-weight-bold"
            >BATAL</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="#CFA22D" class="cyber-save-btn" :loading="loading" @click="save">
            SIMPAN DATA
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
const BASE_URL = "https://berkah.bondowosokab.go.id:5500";

export default {
  data: () => ({
    search: "",
    loading: false,
    dialog: false,
    subList: [],
    categoryOptions: [],
    imageFile: null,
    previewUrl: null,
    headers: [
      { text: "INDUK KATEGORI", value: "category_name" },
      { text: "SUB KATEGORI", value: "nama_sub" },
      { text: "STATUS", value: "is_active", align: "center", width: "130px" },
      { text: "VISUAL ICON", value: "icon_subcategories", sortable: false },
      { text: "AKSI", value: "actions", sortable: false, align: "end" },
    ],
    editedIndex: -1,
    editedItem: {
      id: null,
      category_id: null,
      nama_sub: "",
      icon_subcategories: "",
      is_active: 1,
    },
    defaultItem: {
      id: null,
      category_id: null,
      nama_sub: "",
      icon_subcategories: "",
      is_active: 1,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "REGISTRASI DATA" : "MODIFIKASI DATA";
    },
  },

  mounted() {
    this.fetchData();
    this.fetchCategories();
  },

  methods: {
    createPreview() {
      if (!this.imageFile) {
        this.previewUrl = null;
        return;
      }
      this.previewUrl = URL.createObjectURL(this.imageFile);
    },
    async fetchCategories() {
      try {
        const res = await axios.get(`${BASE_URL}/master/category`);
        const data = res.data.response ? res.data.response.data : res.data.data || [];
        this.categoryOptions = data;
      } catch (e) {
        console.error("Error categories:", e);
      }
    },
    async fetchData() {
      this.loading = true;
      try {
        const res = await axios.get(`${BASE_URL}/master/sub-category`);
        const data = res.data.response ? res.data.response.data : res.data.data || [];
        this.subList = data;
      } catch (e) {
        console.error("Error sub-categories:", e);
      } finally {
        this.loading = false;
      }
    },
    openDialog(item) {
      this.editedIndex = item ? this.subList.indexOf(item) : -1;
      this.editedItem = item
        ? Object.assign({}, item)
        : Object.assign({}, this.defaultItem);
      this.previewUrl = item && item.icon_url ? item.icon_url : null;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.imageFile = null;
        this.previewUrl = null;
      });
    },
    async save() {
      if (!this.editedItem.category_id || !this.editedItem.nama_sub)
        return alert("Sistem: Data tidak lengkap!");
      this.loading = true;
      try {
        const formData = new FormData();
        formData.append("category_id", this.editedItem.category_id);
        formData.append("nama_sub", this.editedItem.nama_sub);
        formData.append("is_active", this.editedItem.is_active);

        if (this.imageFile) formData.append("file", this.imageFile);

        const config = { headers: { "Content-Type": "multipart/form-data" } };

        if (this.editedIndex > -1) {
          await axios.put(
            `${BASE_URL}/master/sub-category/${this.editedItem.id}`,
            formData,
            config
          );
        } else {
          await axios.post(`${BASE_URL}/master/sub-category`, formData, config);
        }
        this.fetchData();
        this.close();
      } catch (e) {
        alert("Sistem: Eksekusi gagal");
      } finally {
        this.loading = false;
      }
    },
    async deleteItem(item) {
      if (confirm(`PURGE DATA: ${item.nama_sub}? Tindakan ini tidak dapat dibatalkan.`)) {
        try {
          await axios.delete(`${BASE_URL}/master/sub-category/${item.id}`);
          this.fetchData();
        } catch (e) {
          alert("Sistem: Penghapusan gagal");
        }
      }
    },
  },
};
</script>

<style scoped>
.cyber-mapping-container {
  background: transparent;
}
.cyber-text {
  letter-spacing: 4px !important;
  color: white !important;
  text-shadow: 0 0 12px rgba(1, 140, 116, 0.6);
}
.secondary-text {
  color: #cfa22d !important;
  letter-spacing: 1px;
}
.glass-card {
  background: rgba(0, 20, 18, 0.9) !important;
  backdrop-filter: blur(15px);
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}
.cyber-table {
  background: transparent !important;
}
.cyber-table >>> th {
  background: rgba(1, 140, 116, 0.15) !important;
  color: #cfa22d !important;
  font-weight: 800;
  border-bottom: 2px solid #018c74 !important;
}
.icon-scan-frame {
  padding: 6px;
  display: inline-block;
  background: rgba(1, 140, 116, 0.05);
  border: 1px solid rgba(1, 140, 116, 0.3);
  border-radius: 10px;
}
.cyber-modal {
  background: rgba(0, 18, 16, 0.98) !important;
  border: 1px solid #018c74 !important;
  box-shadow: 0 0 40px rgba(0, 0, 0, 0.8) !important;
}
.modal-header-line {
  height: 3px;
  background: linear-gradient(90deg, #018c74, #cfa22d, #018c74);
}
.cyber-btn-add {
  background: linear-gradient(135deg, #018c74 0%, #002d25 100%) !important;
  color: white !important;
  border: 1px solid #cfa22d !important;
  font-weight: 900;
}
.cyber-save-btn {
  color: #001a16 !important;
  font-weight: 900 !important;
}
.preview-container {
  position: relative;
  padding: 20px;
  background: rgba(1, 140, 116, 0.05);
  border: 1px solid #018c74;
  border-radius: 12px;
  overflow: hidden;
}
.scanning-line {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: #cfa22d;
  box-shadow: 0 0 15px #cfa22d;
  animation: scan 2.5s linear infinite;
}
@keyframes scan {
  0% {
    top: 0;
  }
  100% {
    top: 100%;
  }
}
.shadow-glow-teal {
  box-shadow: 0 0 10px rgba(1, 140, 116, 0.4);
}
.shadow-glow-gold {
  box-shadow: 0 0 15px rgba(207, 162, 45, 0.3);
}
.glow-hover:hover {
  filter: drop-shadow(0 0 5px #018c74);
  transform: scale(1.15);
}
.glow-hover-red:hover {
  filter: drop-shadow(0 0 5px #ff5252);
  transform: scale(1.15);
}

.cyber-page,
.cyber-container,
.cyber-portal {
  background: transparent !important;
}

.cyber-title,
.cyber-text,
.cyber-id,
.cyber-desc,
.cyber-item-text {
  color: #1c2b28 !important;
  text-shadow: none !important;
}

.secondary-text {
  color: #018c74 !important;
  text-shadow: none !important;
}

.glass-card,
.cyber-card,
.cyber-dialog,
.cyber-dialog-card,
.cyber-modal,
.cyber-map-container,
.cyber-mapping-container,
.cyber-news-container,
.cyber-moments,
.cyber-carousel,
.cyber-agenda,
.cyber-sosmed-header,
.cyber-map-box,
.cyber-map {
  background: #ffffff !important;
  border: 1px solid #eef1f0 !important;
  backdrop-filter: none !important;
  color: #1c2b28 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
}

.dialog-header,
.dialog-header-gradient {
  background: #f4f7f6 !important;
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.dialog-header .white--text,
.dialog-header-gradient .white--text,
.cyber-dialog .white--text,
.cyber-dialog-card .white--text {
  color: #1c2b28 !important;
}

.dialog-neon-line,
.neon-line {
  background: linear-gradient(90deg, #018c74, #cfa22d, #018c74) !important;
}

.transparent-table,
.cyber-table,
.transparent-tabs {
  background: #ffffff !important;
  color: #1c2b28 !important;
}

.transparent-table >>> th,
.cyber-table >>> th {
  background: #f4f7f6 !important;
  color: #018c74 !important;
  font-weight: 800;
  border-bottom: 2px solid #018c74 !important;
}

.transparent-table >>> td,
.cyber-table >>> td {
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.transparent-table >>> .v-data-table__empty-wrapper,
.cyber-table >>> .v-data-table__empty-wrapper {
  color: #9aa6a3 !important;
}

.cyber-input,
.cyber-field,
.cyber-search,
.cyber-search-field,
.cyber-search-bar,
.cyber-input-mini,
.cyber-input-dense,
.cyber-input-highlight,
.cyber-input-coord,
.cyber-coord-field,
.cyber-select-dense,
.cyber-file-input,
.cyber-datepicker {
  color: #1c2b28 !important;
}

.cyber-input >>> .v-input__control,
.cyber-field >>> .v-input__control,
.cyber-search >>> .v-input__control,
.cyber-search-field >>> .v-input__control,
.cyber-search-bar >>> .v-input__control,
.cyber-input-mini >>> .v-input__control,
.cyber-input-dense >>> .v-input__control,
.cyber-input-highlight >>> .v-input__control,
.cyber-input-coord >>> .v-input__control,
.cyber-coord-field >>> .v-input__control,
.cyber-select-dense >>> .v-input__control,
.cyber-file-input >>> .v-input__control,
.cyber-datepicker >>> .v-input__control {
  background: #ffffff !important;
  border-radius: 10px;
}

.cyber-input >>> input,
.cyber-field >>> input,
.cyber-search >>> input,
.cyber-search-field >>> input,
.cyber-search-bar >>> input,
.cyber-input-mini >>> input,
.cyber-input-dense >>> input,
.cyber-input-coord >>> input,
.cyber-coord-field >>> input,
.cyber-datepicker >>> input,
.cyber-input >>> .v-label,
.cyber-field >>> .v-label,
.cyber-search >>> .v-label,
.cyber-search-field >>> .v-label,
.cyber-search-bar >>> .v-label,
.cyber-select-dense >>> .v-label,
.cyber-datepicker >>> .v-label {
  color: #1c2b28 !important;
}

.cyber-btn-add,
.cyber-add-btn,
.cyber-add-sosmed-btn {
  background: linear-gradient(135deg, #018c74 0%, #02b395 100%) !important;
  color: #ffffff !important;
  font-weight: 700;
  border: none !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.cyber-btn-save,
.cyber-save-btn {
  background: #018c74 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.icon-scan-box,
.icon-scan-frame,
.preview-container,
.preview-hex-frame,
.preview-mini-frame,
.preview-scanner {
  background: #f4f7f6 !important;
  border: 1px solid #eef1f0 !important;
}

.preview-tag {
  background: #eaf6f3 !important;
  color: #018c74 !important;
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}

.scan-overlay {
  display: none !important;
}

.shadow-glow,
.shadow-glow-gold,
.shadow-glow-teal {
  box-shadow: 0 6px 16px rgba(1, 140, 116, 0.15) !important;
}

.action-glow.edit-btn,
.action-glow.delete-btn {
  background: transparent !important;
}


.v-data-table >>> .white--text {
  color: #1c2b28 !important;
}
.plain-description {
  color: #4a5a57 !important;
}

</style>
